import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { Title } from "./GlobalMassssage";
import { AuthContext } from "../../Context/ContextFunctions";
import { isSessionExpired } from "../../Middleware/Utils";

const Layout = ({ children }) => {
  const location = useLocation();
  let title;
  const navigate = useNavigate();
  const storedAuth = JSON.parse(localStorage.getItem("login"));
  const token = storedAuth?.logInItem?.token;
  const { authDetails, isAccessible } = useContext(AuthContext);
  // Check if the current route is "/login"
  const isLoginPage =
    location.pathname === "/login" || location?.pathname === "/logout";

  useEffect(() => {
    if (
      token === null ||
      token === undefined ||
      token === "" ||
      isLoginPage ||
      storedAuth?.logInItem?.isCRMUser === false
      // storedAuth?.logInItem?.roleTypeID != 2
    ) {
      localStorage.clear(); // Clear localStorage
      navigate("/login");
    }
    if (isSessionExpired()) {
      localStorage.clear(); // or remove only session-specific data
      navigate("/login");
    }
  }, []);



  switch (location.pathname) {
    case "/":
      title = "Dashboard | " + Title;
      break;
    case "/lead":
      if (isAccessible?.Lead?.canView) {
        title = "Lead | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/enquiry-received":
      if (isAccessible?.EnquiryReceived?.canView) {
        title = "Enquiry Received | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/estBoq":
      if (isAccessible?.EstBoq?.canView) {
        title = "Est & Boq | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/quotation":
      if (isAccessible?.Quotation?.canView) {
        title = "Quotation | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/salesLog":
      if (isAccessible?.SalesLog?.canView) {
        title = "Sales Log | " + Title;
      } else {
        navigate('/')
      }

      break;

    case "/accountLog":
      title = "Account Log | " + Title;
      break;
    case "/dvr":
      title = "DVR | " + Title;
      break;
    case "/followup":
      if (isAccessible?.FollowUp?.canView) {
        title = "Followup | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/addUpdateQuotation":
      if (isAccessible?.Quotation?.canInsert) {
        title = " Quotation | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/viewQuotation":
      if (isAccessible?.Quotation?.canView) {
        title = " Quotation | " + Title;
      } else {
        navigate('/')
      }

      break;
    case "/login":
      title = " Login | " + Title;
      break;
    case "/profile":
      title = " Profile | " + Title;
      break;
    case "/detailedLog":

      title = " Logs | " + Title;
      break;
    case "/invoice":
      title = " Invoice | " + Title;
      break;
    case "/previewPO":
      title = " PO Preview | " + Title;
      break;
    case "/previewInvoiceReceipt":
      title = " Invoice Receipt | " + Title;
      break;
    case "/preViewInvoice":
      title = " Invoice Preview | " + Title;
      break;
    case "/task-management":
      title = " Task Management| " + Title;
      break;
    case "/help-requested-list":
      title = "Help requested list | " + Title;
      break;
    case "/notes-attachments-list":
      title = "Notes & Attachments list | " + Title;
      break;

  }
  document.title = title;
  console.log("title", title);
  return (
    <div className="min-h-screen bg-white-100 flex flex-col sticky">
      {/* Render Navbar only if not on login page */}
      {!isLoginPage && <Navbar />}
      <main
        className={`flex-grow mx-auto px-1 py-1 w-full  ${isLoginPage ? "flex items-center justify-center" : ""
          }`}
      >
        {children}
      </main>
      {/* Render Footer only if not on login page */}
      {!isLoginPage && (
        <footer
          style={{
            background: "white",
            zIndex: 1000,
            display: location?.pathname === "/addUpdateQuotation" ? "none" : "block",
          }}
          className="bg-white dark:bg-dark-800 sticky bottom-0"
        >
          <div className="w-full mx-auto max-w-screen-xl p-2 md:flex md:items-center md:justify-between">
            <span
              style={{
                color: "gray",
                fontWeight: "bold",
                fontFamily: "roboto",
                fontSize: "14px",
                margin: "auto",
              }}
            >
              © 2025 <a>Surya Group</a>. All Rights Reserved.
            </span>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
